import { CONFWORD, type Entry } from './data/grimoire';

export type ChipInfo = { cls: string; text: string };

// Returns the register-confidence chip for an entry.
//   reg-3 → "имагинальное" (myth)
//   reg-4 → "за линией"  (beyond)
//   else  → CONFWORD[conf]
export function chipFor(e: Entry): ChipInfo {
  if (e._reg === 'reg-3') return { cls: 'myth', text: 'имагинальное' };
  if (e._reg === 'reg-4') return { cls: 'beyond', text: 'за линией' };
  return { cls: e.conf || 'mid', text: CONFWORD[e.conf || 'mid'] };
}

// Smooth-scroll to an element id, accounting for the sticky rail.
export function scrollToId(id: string) {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: 'smooth' });
}

// Trap Tab focus inside `node`. Returns a cleanup that removes the listener.
export function focusTrap(node: HTMLElement) {
  function onKey(e: KeyboardEvent) {
    if (e.key !== 'Tab') return;
    const f = node.querySelectorAll<HTMLElement>(
      'button,[href],[tabindex]:not([tabindex="-1"])',
    );
    if (!f.length) return;
    const first = f[0];
    const last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }
  node.addEventListener('keydown', onKey);
  return {
    destroy() {
      node.removeEventListener('keydown', onKey);
    },
  };
}
